export const redirectPolicy = link => {
  try {
    const { pathname } = new URL(link)
    window.location.pathname = pathname
  } catch (e) {
    window.location.pathname = link
  }
}
